<template>
  <el-table
    v-bind="$attrs"
    border
    :data="tableData"
    style="width: 100%; text-align: center"
    :class="isCombineCol ? 'combine' : ''"
  >
    <template v-for="(item, index) in columns">
      <el-table-column
        v-if="item.type === 'index'"
        :align="item.align || 'left'"
        type="index"
        width="100"
        :label="item.label"
        :key="index"
      >
      </el-table-column>
      <el-table-column
        v-else
        :prop="item.key"
        :width="item.width || ''"
        :label="item.label"
        :key="index"
        :align="item.align || 'left'"
      >
        <template slot-scope="scope">
          <span :style="`font-weight:600 !important;`" v-if="item.bold">
            <span
              :style="`color:${scope.row._color.color || '#000'}`"
              v-if="scope.row._color && scope.row._color.key === item.key"
            >
              {{ scope.row[item.key] }}
            </span>
            <span v-else>
              {{ scope.row[item.key] }}
            </span>
          </span>
          <span v-else>
            <span
              :style="`color:${scope.row._color.color || '#000'}`"
              v-if="scope.row._color && scope.row._color.key === item.key"
            >
              {{ scope.row[item.key] }}
            </span>
            <span v-else>
              {{ scope.row[item.key] }}
            </span></span
          >
        </template>
      </el-table-column>
    </template>
  </el-table>
</template>

<script>
export default {
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    columns: {
      type: Array,
      default: () => []
    },
    isCombineCol: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  methods: {},
  watch: {}
}
</script>

<style lang="less" scoped>
/deep/ .el-table__cell {
  padding: 6px 0 !important;
  color: #000 !important;
  font-size: 18px !important;
  border-color: #000 !important;
  border-width: 1.5px !important ;
}
/deep/ .el-table {
  border-color: #000 !important;
  border-width: 1.5px !important ;
}
.el-table::before{
  height: 0px !important;
}
 .el-table--border::after, .el-table--group::after{
   width: 0px !important;
   background: transparent !important;
}
.el-table--border,
.el-table--group {
  border: 1.5px solid #000 !important ;
}
/deep/ .el-table__row {
  td {
    &:last-child {
      border-right: none !important;
    }
  }
}
/deep/ .el-table__header-wrapper {
  .el-table__header {
    thead {
      tr {
        th {
          &:nth-last-child(-n + 2) {
            border-right: none !important;
          }
        }
      }
    }
  }
}
/deep/ .el-table__body {
  tr {
    &:last-child {
      td {
        border-bottom: none !important;
      }
    }
  }
}
.combine {
  /deep/ .el-table__body {
    tr {
      &:nth-last-child(-n + 2) {
        td {
          &:first-child{

            border-bottom: none !important;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/operateManage/hospitalUserManage/components/table.vue